export const categories = [
  {
    slug: 'platform-intro',
    name: '平台介绍',
    description: '全面了解91.cn com平台的背景、定位与核心价值',
    icon: 'ri-information-line',
    articleCount: 8,
  },
  {
    slug: 'features',
    name: '功能解析',
    description: '深入解析91.cn com平台的各项功能与特色',
    icon: 'ri-stack-line',
    articleCount: 10,
  },
  {
    slug: 'user-guide',
    name: '使用指南',
    description: '详细的使用教程与操作指引，快速上手91.cn com',
    icon: 'ri-book-open-line',
    articleCount: 12,
  },
  {
    slug: 'safety',
    name: '安全建议',
    description: '安全使用91.cn com的注意事项与防护措施',
    icon: 'ri-shield-check-line',
    articleCount: 6,
  },
  {
    slug: 'faq',
    name: '常见问题',
    description: '关于91.cn com的常见疑问与详细解答',
    icon: 'ri-question-answer-line',
    articleCount: 15,
  },
];

export const categoryMeta: Record<string, { title: string; description: string; keywords: string }> = {
  'platform-intro': {
    title: '91.cn com平台介绍 - 平台背景、定位与核心价值',
    description: '深入了解91.cn com平台的发展背景、市场定位、核心价值与未来规划。91.cn com作为综合性网络内容平台，致力于为用户提供优质内容服务。',
    keywords: '91.cn com平台介绍,91.cn com平台背景,91.cn com定位,91.cn com核心价值',
  },
  'features': {
    title: '91.cn com功能解析 - 平台功能详解与特色介绍',
    description: '详细解析91.cn com平台的各项核心功能、技术特色与使用场景。涵盖内容管理、用户互动、个性化推荐等全方位功能说明。',
    keywords: '91.cn com功能解析,91.cn com功能详解,91.cn com特色功能,91.cn com平台功能',
  },
  'user-guide': {
    title: '91.cn com使用指南 - 操作教程与使用技巧',
    description: '提供91.cn com平台的完整使用指南，包括注册登录、功能操作、个性化设置等详细教程，帮助用户快速上手并高效使用平台。',
    keywords: '91.cn com使用指南,91.cn com操作教程,91.cn com使用方法,91.cn com使用技巧',
  },
  'safety': {
    title: '91.cn com安全建议 - 安全使用须知与防护措施',
    description: '提供91.cn com平台的安全使用建议，包括账号安全、隐私保护、内容安全等全方位的安全防护指导，确保用户安全合规使用平台。',
    keywords: '91.cn com安全建议,91.cn com安全使用,91.cn com隐私保护,91.cn com安全须知',
  },
  'faq': {
    title: '91.cn com常见问题 - 疑问解答与帮助中心',
    description: '汇总91.cn com平台用户最常遇到的问题及详细解答，涵盖账号问题、功能使用、支付问题、内容管理等多个方面的常见疑问。',
    keywords: '91.cn com常见问题,91.cn com FAQ,91.cn com帮助中心,91.cn com问题解答',
  },
};